import { useState } from "react";

const favicon = (url) => {
  try {
    const host = new URL(url).hostname.replace(/^www\./, "");
    return `https://www.google.com/s2/favicons?sz=64&domain=${host}`;
  } catch {
    return null;
  }
};

// Premium brand logo tile for AI builders. Falls back to a lettered badge.
export const BuilderLogo = ({ url, name, size = 32, tile = true }) => {
  const [err, setErr] = useState(false);
  const src = favicon(url);
  const inner =
    err || !src ? (
      <span className="font-extrabold text-[#8a6d1a]" style={{ fontSize: size * 0.5 }}>
        {(name || "?").charAt(0).toUpperCase()}
      </span>
    ) : (
      <img
        src={src}
        alt={name}
        onError={() => setErr(true)}
        className="object-contain"
        style={{ width: size * 0.68, height: size * 0.68 }}
      />
    );
  if (!tile) return inner;
  return (
    <span
      className="inline-flex items-center justify-center rounded-lg bg-white shadow-sm ring-1 ring-black/5 shrink-0"
      style={{ width: size, height: size }}
      data-testid={`builder-logo-${(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      {inner}
    </span>
  );
};
